export const groupLimits = `<p><strong>Navigation</strong>: Payments / Group Limits</p>
<p>A Group Limit is a solution for customers to have a credit facility over a group of accounts, spanning various account products, different currencies and different legal entities. The structure of the hierarchy can be single level or multi-level. For all the participating accounts within the hierarchy there is a real-time limit check against the available balance for all debit postings.&nbsp;</p>
<p><img src='${process.env.PUBLIC_URL}/images/3/8/1.png' /></p>
<p>This is a view-only page; you cannot action any transactions, but you can view, print or export information.&nbsp;</p>
<p>The summary balances are:</p>
<ul>
  <li>Closing available balance</li>
  <li>Closing booked balance&nbsp;</li>
  <li>Interim available balance</li>
  <li>Interim booked balance</li>
</ul>
<p><strong>Note: </strong>Only Lloyds Bank accounts can participate in a Group Limit</p>
<p><strong>Account status</strong>&nbsp;</p>
<p>When searching for an account it is possible to select the status of the account via a drop-down menu. The choices are:</p>
<ul>
  <li>In release process, created</li>
  <li>Active, not yet used</li>
  <li>Active, used</li>
  <li>Being terminated</li>
</ul>`;


// WEBPACK FOOTER //
// ./src/components/content/accounts/groupLimits.ts